import { useCallback, useState } from 'react';

import { useDebounce } from 'v2/hooks/useDebounce';

interface UseFilter<T> {
  filter: T;
  debouncedFilter: T;
  onChange: (key: keyof T, value: T[keyof T]) => void;
}

export function useFilter<T extends Record<string, any>>(initialValues: T): UseFilter<T> {
  const [filter, setFilter] = useState<T>(initialValues);
  const debouncedFilter = useDebounce(filter, 400);

  const handleChange = useCallback((key: keyof T, value: T[keyof T]) => {
    setFilter((prevFilter) => ({ ...prevFilter, [key]: value }));
  }, []);

  return { filter, debouncedFilter, onChange: handleChange };
}
